import React from 'react';
import ButtonGeneral from './ButtonGeneral';

type Props = {
    callbackCancel: () => void;
    title?: string;
    loading?: boolean;
    locked?: boolean;
    message?: string;
};

const ButtonCancelForm = ({
    callbackCancel,
    title = 'Cancelar',
    loading = false,
    locked = false,
    message = 'No se puede cancelar este registro.'
}: Props) => {
    return (
        <ButtonGeneral
            onClick={callbackCancel}
            title={title}
            loading={loading}
            locked={locked}
            errorMessage={message}
            variant="secondary"
            size="small"
            icon="fa-times"
        />
    );
};

export default ButtonCancelForm;
